import { UsersManager } from "@/components/Settings/UsersManager";

export function SettingsUsers() {
  return (
    <div className="space-y-6 p-6">
      <div>
        <h1 className="text-3xl font-bold">Users</h1>
        <p className="mt-2 text-muted-foreground">
          Manage users, group assignment, roles, and direct permissions.
        </p>
      </div>
      <UsersManager />
    </div>
  );
}

